var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDottedCircleLeft = function SvgDottedCircleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.25c0 1.105-.911 2.025-1.976 1.733C7.162 18.129 4.75 15.326 4.75 12c0-3.326 2.412-6.129 5.524-6.983 1.065-.292 1.976.628 1.976 1.733v10.5ZM17.258 17.415a7.226 7.226 0 0 1-2.508 1.835M18.975 9.834c.18.688.275 1.415.275 2.166 0 .751-.095 1.478-.275 2.166M14.75 4.75a7.226 7.226 0 0 1 2.508 1.835",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDottedCircleLeft;